export enum StandardDetailTabType {
  Additional = 'additional',
  Question = 'question',
  Scoring = 'scoring',
}

export const QUESTION_SENTENCE_SEPARATOR_REGEX = /[。.?]/;
export const QUESTION_SENTENCE_SEPARATOR_CAPTURING_REGEX = /([。.?])/;
export const QUESTION_PARAGRAPH_SEPARATOR_REGEX = /\n/;
export const QUESTION_PARAGRAPH_SEPARATOR_CAPTURING_REGEX = /(\n)/;
export const QUESTION_PARAGRAPH_INDENTATION = '\t';

export const STANDARD_DETAIL_COLOR_NUMBER = [0, 1, 2, 3, 4, 5] as const;

export type StandardDetailColorNumber = (typeof STANDARD_DETAIL_COLOR_NUMBER)[number];

export const STANDARD_DETAIL_COLOR_MAX_NUMBER = STANDARD_DETAIL_COLOR_NUMBER.length;

export const STANDARD_DETAIL_LIGHT_STYLE = {
  0: 'bg-green-100',
  1: 'bg-blue-100',
  2: 'bg-yellow-100',
  3: 'bg-purple-200',
  4: 'bg-rose-100',
  5: 'bg-gray-100',
} as Record<StandardDetailColorNumber, string>;

export const STANDARD_DETAIL_NORMAL_STYLE = {
  0: 'bg-green-300',
  1: 'bg-blue-300',
  2: 'bg-yellow-300',
  3: 'bg-purple-300',
  4: 'bg-rose-300',
  5: 'bg-gray-300',
} as Record<StandardDetailColorNumber, string>;

export const STANDARD_DETAIL_DARK_STYLE = {
  0: 'bg-green-600',
  1: 'bg-blue-600',
  2: 'bg-yellow-600',
  3: 'bg-purple-600',
  4: 'bg-rose-600',
  5: 'bg-gray-600',
} as Record<StandardDetailColorNumber, string>;
